import { render, staticRenderFns } from "./AddAccountModal.vue?vue&type=template&id=2f56dd1b&scoped=true&"
import script from "./AddAccountModal.vue?vue&type=script&lang=js&"
export * from "./AddAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./AddAccountModal.vue?vue&type=style&index=0&id=2f56dd1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f56dd1b",
  null
  
)

export default component.exports